export default "/assets/images/cooking-video.83d734af2f9d6799.mp4";